import type { RecordView } from '@kit/sync/types/record-view';
import { useRecords } from '@/entities/shared/record/use-records';
import type { KitDocument } from '../schemas/kit-document';

export function useDocuments(): RecordView<KitDocument>[] | undefined {
  return useRecords<KitDocument>('documents');
}
